import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import React from "react";
import { EXCLUSION_TYPES, exclusionNamesNew } from "../../../../utils/consts";

const ExclusionNamesSelect = ({
  t,
  checkedType,
  setCheckedType,
}) => {

  const handleChangeSelect = (e) => {
    let data = e.target.value;
    setCheckedType(data);
  };

  return (
    <>
      <FormControl>
        <InputLabel id="exclusion-simple-select-label">{t("exclusions.table.type")}</InputLabel>
        {/* No need to change on Autocomplete component (few options) */}
        <Select
          labelId="exclusion-simple-select-label"
          id="service-simple-select"
          value={checkedType ?? null}
          onChange={handleChangeSelect}
        >
          {Object.keys(EXCLUSION_TYPES).map((value, key) => (
            <MenuItem
              key={key}
              value={value}
            >
              {value.charAt(0).toUpperCase() + value.slice(1)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </>
  );
};

export default ExclusionNamesSelect;